var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},[_c('v-container',{attrs:{"fluid":""}},[_c('image-route-component',{attrs:{"name":"Raid Guides","logoPath":"/assets/wow/raidguides.png","path":"/raidguides"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }